module.exports = __webpack_public_path__ + "static/media/screen-1.84623f5c.jpg";